module.exports = "<ng-http-loader [entryComponent]=\"spinnerComponent\"> </ng-http-loader>\r\n<router-outlet></router-outlet>"